import { useTranslation } from 'react-i18next';

export default function Taxonomy() {
  const { t } = useTranslation('home');
  const categories = t('taxonomy.categories', { returnObjects: true }) as Array<{ code: string; title: string; desc: string }>;

  return (
    <section className="py-10 md:py-14 bg-white">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <div className="text-xs font-medium text-slate-400 uppercase tracking-wider mb-2">{t('taxonomy.subtitle')}</div>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-900">
              {t('taxonomy.title')}
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            <div className="bg-orange-50 border border-orange-100 rounded-lg p-4 flex flex-col justify-center">
              <div className="text-sm font-bold text-slate-900 mb-1">{t('taxonomy.codeRule')}</div>
              <div className="text-xs text-orange-700">{t('taxonomy.codeRuleDesc')}</div>
            </div>
            {categories.map((cat) => (
              <div
                key={cat.code}
                className="bg-white border border-slate-200 rounded-lg p-4 hover:border-orange-300 hover:shadow-sm transition-all"
              >
                <div className="text-xs font-medium text-slate-400 mb-2">{cat.code}</div>
                <div className="text-sm font-semibold text-slate-900 mb-1">{cat.title}</div>
                <div className="text-xs text-slate-500">{cat.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}